import { useRouter } from "next/router";
import useTeam from "./useTeam";

const useIsTeam = (): {
  isTeam: boolean;
  team: string;
  id: string;
  teamData: any;
} => {
  const router = useRouter();
  const isTeam = router.pathname.includes("/teams/");
  const { team } = useTeam(isTeam ? (router.query.team as string) : "");
  return {
    isTeam: router.pathname.includes("/teams/"),
    team: (router.query.team as string) || "",
    id: team?.id || "",
    teamData: team,
  };
};

export default useIsTeam;
